/**
 * Caregiver identity colour and initials.
 *
 * The server sends both for people it knows about. This is the fallback for
 * places that only hold a name — it must agree with `app/domain/insight.py`,
 * or the same person appears in two colours on two screens.
 */
const AVATAR_COLORS = [
  '#006B3F', // green
  '#9C767C', // plum
  '#497085', // ocean blue
  '#5C6350', // dark green
  '#A2B5C2', // blue gray
  '#9FA689', // light green
] as const;

export function avatarColor(seed: string, stored?: string | null): string {
  if (stored) return stored;
  let total = 0;
  for (const char of seed) total += char.charCodeAt(0);
  return AVATAR_COLORS[total % AVATAR_COLORS.length]!;
}

export function initials(fullName: string): string {
  const parts = fullName.replace(/\./g, ' ').split(/\s+/).filter(Boolean);
  return parts.slice(0, 2).map((part) => part[0]!).join('').toUpperCase() || '?';
}
